/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { createApiResponseSchema, type IAPI } from '../../apiResponse';
import { type IMovieRatingData, movieRatingDataSchema } from '../movie-rating-schema';

export const watchStatusSchema = movieRatingDataSchema.extend({ collectionId: z.number() });

export interface IWatchStatus extends IMovieRatingData {
  collectionId: number;
}

const watchStatusBatchDataSchema = z.object({ statuses: z.array(watchStatusSchema) });

export interface IWatchStatusBatchData {
  statuses: IWatchStatus[];
}

export const getWatchStatusBatchV1ResponseSchema = createApiResponseSchema(
  watchStatusBatchDataSchema,
) as z.ZodSchema<IAPI<IWatchStatusBatchData>>;

export type IGetWatchStatusBatchV1Response = IAPI<IWatchStatusBatchData>;
